import { useState, useEffect, useContext } from "react";
import { Input } from "../../../components/Input/Input";
import logo from "../../../assets/recode_pro-logo-1.svg";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrashCan,
  faKey,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../../services/Auth";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import styles from "../../Sgr/Sgr.module.scss";
import { AlignCenter } from "../../../components/Box/Box";
import {
  ContainedBtn,
  OutlineBtn,
} from "../../../components/ButtonTypes/Button";
import { swalTheme } from "../../../services/Swal";

function RecodePro() {
  const { user } = useContext(AuthContext);
  const [filtro, setFiltro] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [flip, setFlip] = useState(true);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const paginationSize = 25;
  const paginationInitial = (currentPage - 1) * paginationSize;
  const paginationTotal = Math.ceil(
    usuarios.filter(
      (f) =>
        f.nome.toLowerCase().includes(filtro.toLowerCase()) ||
        f.email.toLowerCase().includes(filtro.toLowerCase())
    ).length / paginationSize
  );

  const currentYear = new Date().getFullYear();
  const [anoProcessoSeletivo, setAnoProcessoSeletivo] = useState(currentYear);
  const pattern = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,64})/g;

  const actionButtonsStyle = {
    margin: "0.25em",
  };

  function changeUserPassword(idUsuario) {
    Swal.fire({
      title: "Mudar senha",
      text: "Insira a nova senha para o usuário",
      input: "password",
      icon: "question",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Mudar",
      showLoaderOnConfirm: true,
      ...swalTheme,
      preConfirm: async (novaSenha) => {
        if (!pattern.test(novaSenha))
          return Swal.fire({
            title: "Erro!",
            text: "Precisa de uma senha forte!",
            icon: "error",
            ...swalTheme
          });

        await fetch(
          `${process.env.REACT_APP_BACKEND}/api/RecodePro/MudarSenha`,
          {
            method: "PUT",
            headers: {
              Authorization: user.token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              senha: novaSenha,
              idUsuario: idUsuario,
            }),
          }
        )
          .then((response) => response.json())
          .then((result) => {
            Swal.fire({
              title: result.success ? "Sucesso!" : "Erro!",
              text: result.message, //"Senha de usuário alterada com sucesso!",
              icon: result.success ? "success" : "error",
              ...swalTheme
            });
          })
          .catch((error) => {
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
    });
  }

  function deleteUser(idUsuario) {
    Swal.fire({
      title: "Você tem certeza?",
      text: "O usuário será deletado e este processo não poderá ser revertido.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, quero deletar! ",
      cancelButtonText: "Cancelar!",
      ...swalTheme,
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(
          `${process.env.REACT_APP_BACKEND}/api/RecodePro/ExcluirUsuario?idUsuario=${idUsuario}`,
          {
            method: "PUT",
            headers: { Authorization: user.token },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
            Swal.fire({
              title: data.success ? "Sucesso!" : "Erro!",
              icon: data.success ? "success" : "error",
              text: data.message,
              ...swalTheme
            }).then(() => {
              setFlip((self) => !self);
              setFiltro("");
            });
          })
          .catch((err) => console.error(err));
      }
    });
  }

  useEffect(() => {
    setLoading(true);
    fetch(
      `${process.env.REACT_APP_BACKEND}/api/RecodePro/BuscarListaUsuarios?AnoProcessoSeletivo=${anoProcessoSeletivo}`,
      {
        method: "GET",
        headers: { Authorization: user.token },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setUsuarios(data);
      })
      .finally(() => setLoading(false));
  }, [anoProcessoSeletivo, user.token, flip]);

  return (
    <>
      <AlignCenter>
        <section>
          <img src={logo} className={styles.logo} alt="logo" />
        </section>
      </AlignCenter>

      <h1>Gerenciar Usuários</h1>

      <Input
        className={styles.input}
        label="Ano do processo seletivo"
        type="number"
        value={anoProcessoSeletivo}
        onChange={(e) => {
          setAnoProcessoSeletivo(e.target.value);
          setCurrentPage(1);
        }}
        max={currentYear}
        disabled={loading}
      />

      <Input
        className={styles.input}
        label="Localizar"
        placeholder="Nome ou e-mail"
        type="search"
        value={filtro}
        onChange={(e) => {
          setFiltro(e.target.value);
          setCurrentPage(1);
        }}
      />

      <br />
      {loading ? (
        "Carregando"
      ) : (
        <>
          {usuarios.length === 0 ? (
            "Sem usuários para mostrar"
          ) : (
            <>
              <div className={styles.containerTable}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <td colSpan={3}>{usuarios.length} usuarios totais</td>
                    </tr>
                  </thead>
                  <tbody>
                    {usuarios
                      .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
                      .filter(
                        (f) =>
                          f.nome.toLowerCase().includes(filtro.toLowerCase()) ||
                          f.email.toLowerCase().includes(filtro.toLowerCase())
                      )
                      .slice(
                        paginationInitial,
                        paginationInitial + paginationSize
                      )
                      .map((usuario, idUsuario) => (
                        <tr key={idUsuario}>
                          <td>{usuario.nome}</td>
                          <td>{usuario.email}</td>
                          <td>
                            <ContainedBtn
                              style={actionButtonsStyle}
                              className={styles.button}
                              onClick={() =>
                                changeUserPassword(usuario.idUsuario)
                              }
                            >
                              <FontAwesomeIcon icon={faKey} />
                            </ContainedBtn>

                            <ContainedBtn

                              style={actionButtonsStyle}
                              className={styles.button}
                              onClick={() => deleteUser(usuario.idUsuario)}
                            >
                              <FontAwesomeIcon icon={faTrashCan} />
                            </ContainedBtn>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              <center>
                <OutlineBtn
                  className={styles.button}
                  disabled={parseInt(currentPage) === 1 ? true : false}
                  onClick={() => setCurrentPage((c) => parseInt(c) - 1)}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />{" "}
                </OutlineBtn>
                (
                <input
                  label="Página"
                  type="number"
                  value={currentPage}
                  onChange={(e) => setCurrentPage(e.target.value)}
                  min={1}
                  max={paginationTotal}
                />{" "}
                / {paginationTotal})
                <OutlineBtn
                  className={styles.button}
                  disabled={parseInt(currentPage) === paginationTotal}
                  onClick={() => setCurrentPage((c) => parseInt(c) + 1)}
                >
                  <FontAwesomeIcon icon={faChevronRight} />{" "}
                </OutlineBtn>
              </center>
            </>
          )}
        </>
      )}
    </>
  );
}

export default RecodePro;
